<template>
  <o-form-wrapper
    :form-state="formState"
    :schema="schema"
    :server-errors="_se"
    :v="$v.item"
    v-model="item"
  >
    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="name"
    >
      <o-text-field
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="name"
        v-bind="schema.fields.name"
        v-model="item.name"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="crew_supplier"
    >
      <o-select
        :form-state="formState"
        :items="optionCrewItems"
        :loading="optionCrewWorking"
        :server-errors="_se"
        :validators="$v.item"
        add-title="Create New"
        allow-add
        name="crew_supplier"
        sort-field="name"
        store-name="Supplier"
        text-field="name"
        v-bind="schema.fields.crew_supplier"
        v-model="item.crew_supplier"
        value-field="id"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <crew-form
            :form-state="formState"
            :item="item"
            :server-errors="serverErrors"
            in-modal
          ></crew-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="crew_supplier"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.crew_supplier"
        :items="optionCrewSupplierItems"
        text-field="name"
        value-field="id"
        sort-field="name"
        :form-state="formState"
        :loading="optionSupplierWorking"
        name="crew_supplier"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.crew_supplier"
        allow-add
        store-name="Supplier"
        add-title="Create New"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <supplier-form
            :item="item"
            :form-state="formState"
            :server-errors="serverErrors"
            in-modal
          ></supplier-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="crew_leader"
    >
      <o-checkbox
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="crew_leader"
        v-bind="schema.fields.crew_leader"
        v-model="item.crew_leader"
      ></o-checkbox>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="email"
    >
      <o-text-field
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="email"
        v-bind="schema.fields.email"
        v-model="item.email"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="active_start_date"
    >
      <o-date-time
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="active_start_date"
        v-bind="schema.fields.active_start_date"
        v-model="item.active_start_date"
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="active_end_date"
    >
      <o-date-time
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="active_end_date"
        v-bind="schema.fields.active_end_date"
        v-model="item.active_end_date"
      ></o-date-time>
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";

import { default as CrewForm } from "../../supplier/components/ItemForm";
import CrewSupplierMixin from "../../../mixins/CrewSupplierMixin";

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("Employee"),
    CreateCodeTableFetchMixin(["Supplier"]),
    CrewSupplierMixin(),
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,

    CrewForm,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.Employee, {}),
  }),
  methods: {},
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
    optionCrewSupplierItems() {
      const vm = this;
      let results = vm.optionSupplierItems.filter((item) => {
        if (item.supplier_types) {
          return (
            item.supplier_types.includes(14) || item.supplier_types.includes(2)
          );
        }
        return false;
      });
      return results;
    },
  },
  watch: {},
  created() {},
};
</script>
